import styled from 'styled-components';
import clock from '~/assets/icons/clock.svg';
import { Text } from '~/components/ui/Text';
import descBg from '../../assets/images/desc_bg.svg';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 40px;
`;

const StyledGallaryContainer = styled.div`
	position: relative;
	width: 100%;
	height: 310px;
	padding: 20px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 10px;
	overflow: hidden;
`;

const StyledSliderContainer = styled.div`
	position: absolute;
	bottom: 100px;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	align-items: center;
	gap: 8px;
	z-index: 10;
`;

const StyledSliderDot = styled.div<{ $active: boolean }>`
	width: ${(props) => (props.$active ? '40px' : '10px')};
	height: 10px;
	background-color: rgba(255, 255, 255, 0.3);
	border-radius: 10px;
	cursor: pointer;
	transition:
		background-color 0.3s ease,
		width 0.3s ease;
	position: relative;
	overflow: hidden;

	&:hover {
		background-color: rgba(255, 255, 255, 0.5);
	}
`;

const StyledProgressIndicator = styled.div<{ $active: boolean }>`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: #ffffff;
	border-radius: 5px;
	transform-origin: left;
	transition: transform 0.1s ease;
`;

const StyledGallaryImage = styled.div<{ $currentSlide: number }>`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-size: cover;
	background-position: center;
	mask-image: linear-gradient(
		180deg,
		#ffffff 0%,
		rgba(255, 255, 255, 0) 70.19%
	);
	mask-size: 100% 100%;
	mask-repeat: no-repeat;
	mask-position: center;
	-webkit-mask-image: linear-gradient(
		180deg,
		#ffffff 0%,
		rgba(255, 255, 255, 0) 70.19%
	);
	-webkit-mask-size: 100% 100%;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-position: center;
	transition: background-image 0.3s ease;
`;

const StyledTopContainer = styled.div`
	position: relative;
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

const StyledPromoContainer = styled.div`
	display: flex;
	gap: 10px;
	align-items: center;
	height: 30px;
	padding: 0 10px;
	background-color: #eb1818;
	border-radius: 5px;

	.dividers {
		display: flex;
		height: 20px;
	}

	${Text} {
		font-weight: 700;
		font-size: 14px;
		color: #ffffff;
	}

	img {
		width: 14px;
		height: 14px;
		user-select: none;
		pointer-events: none;
	}
`;

const StyledEarningsContainer = styled.div`
	display: flex;
	gap: 10px;
	align-items: center;
	height: 30px;
	padding: 0 10px;
	border-radius: 5px;
	background-color: #111314;

	${Text} {
		color: #ffffff;
		font-size: 14px;
	}

	img {
		opacity: 0.5;
	}
`;

const StyledProgressWrapper = styled.div`
	position: absolute;
	bottom: 20px;
	left: 20px;
	right: 20px;
	display: grid;
	grid-template-columns: 100px 1fr 100px;
	align-items: center;
	padding: 0 20px;
	height: 60px;
	background: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 10px;

	& > ${Text} {
		font-size: 14px;
		color: #ffffff;
		opacity: 0.5;
	}
`;

const StyledProgressXPContainer = styled.div<{ $isMaxLevel: boolean }>`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
		filter: ${(props) => (props.$isMaxLevel ? 'invert(1)' : 'none')};
	}

	${Text} {
		font-weight: 400;
		font-size: ${(props) => (props.$isMaxLevel ? '14px' : '12px')};
		color: ${(props) =>
			props.$isMaxLevel ? '#000000' : 'rgba(255, 255, 255, 0.5)'};
		font-weight: ${(props) => (props.$isMaxLevel ? 500 : 400)};

		span {
			font-size: 14px;
			font-weight: 700;
			color: #ffffff;
		}
	}
`;

const StyledProgessContainer = styled.div`
	position: absolute;
	height: 50px;
	left: 5px;
	right: 5px;
	top: 4px;
`;

const StyledProgress = styled.div`
	background: #2d70d9;
	height: 50px;
	border-radius: 5px;
`;

const StyledDescContainer = styled.div`
	height: 150px;
	padding: 20px;
	background-image: url(${descBg});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	background-color: rgba(255, 255, 255, 0.02);
	border-radius: 10px;
	overflow: hidden;

	${Text} {
		font-weight: 400;
		font-size: 16px;
		color: #ffffff;
		opacity: 0.75;
	}
`;

const StyledTasksContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

const StyledTasksHead = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

const StyledTasksTimer = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;

	${Text} {
		font-size: 16px;
		color: #ffffff;

		&:first-child {
			opacity: 0.25;
		}

		&:last-child {
			min-width: 47px;
			text-align: right;
			font-weight: 700;
			color: #ffb500;
		}
	}
`;

const StyledClock = styled.div`
	width: 16px;
	height: 16px;
	mask-image: url(${clock});
	mask-position: center;
	mask-repeat: no-repeat;
	-webkit-mask-image: url(${clock});
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	background-color: #ffb500;
`;

const StyledTasksGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 20px;
`;

const StyledButtonsGrid = styled.div`
	position: absolute;
	bottom: 40px;
	left: 40px;
	right: 40px;
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 20px;
`;

const StyledButtonContent = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
	}
`;

export {
	StyledButtonContent,
	StyledButtonsGrid,
	StyledClock,
	StyledContainer,
	StyledDescContainer,
	StyledEarningsContainer,
	StyledGallaryContainer,
	StyledGallaryImage,
	StyledProgessContainer,
	StyledProgress,
	StyledProgressIndicator,
	StyledProgressWrapper,
	StyledProgressXPContainer,
	StyledPromoContainer,
	StyledSliderContainer,
	StyledSliderDot,
	StyledTasksContainer,
	StyledTasksGrid,
	StyledTasksHead,
	StyledTasksTimer,
	StyledTopContainer,
};
